import { render, staticRenderFns } from "./updatePwd.vue?vue&type=template&id=e71d497c&scoped=true"
import script from "./updatePwd.vue?vue&type=script&lang=js"
export * from "./updatePwd.vue?vue&type=script&lang=js"
import style0 from "./updatePwd.vue?vue&type=style&index=0&id=e71d497c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71d497c",
  null
  
)

export default component.exports